import { useTranslation } from "react-i18next";
import { OPTIVAL_CONSTANTS } from "../../../../shared/Constants";
import { TableHeadCell } from "../../../../shared/models/TableModels";
import { useAPI } from "../../../../shared/services/api/API";

export const useSkillsUtils = () => {
  const { checkRole } = useAPI();
  const { t } = useTranslation();
  const getSkillzHeaderCell = (): TableHeadCell[] => {
    const tableHeadCell: TableHeadCell[] = [];
    tableHeadCell.push(
      {
        id: "skillsName",
        label: t("opva.skillName"),
        sorting: true,
        sortingProperty: "name",
        width: 12,
        position: "left",
      },
      {
        id: "description",
        label: t("opva.description"),
        sorting: true,
        sortingProperty: "description",
        width: 25,
        position: "left",
      },
      {
        id: "createdBy",
        label: t("opva.createdBy"),
        sorting: true,
        sortingProperty: "createdBy",
        width: 12,
        position: "left",
      },
      {
        id: "userAssigned",
        label: t("opva.userAssigned"),
        sorting: true,
        sortingProperty: "usersAssigned",
        width: 10,
        position: "center",
      },
      {
        id: "validated",
        label: t("opva.validated"),
        sorting: true,
        sortingProperty: "validated",
        width: 10,
        position: "center",
      }
    );
    if (
      checkRole([
        OPTIVAL_CONSTANTS.ORGANIZATION_ADMIN,
        OPTIVAL_CONSTANTS.OPERATIONS_ADMIN,
        OPTIVAL_CONSTANTS.SUPER_ADMIN,
        OPTIVAL_CONSTANTS.CONTENT_ADMIN,
        OPTIVAL_CONSTANTS.CONTENT_EDITOR,
      ])
    ) {
      tableHeadCell.push({
        id: "mapWorkflow",
        label: t("opva.mapWorkflow"),
        sorting: false,
        sortingProperty: "",
        width: 12,
        position: "center",
      });
    }
    if (
      checkRole([
        OPTIVAL_CONSTANTS.ORGANIZATION_ADMIN,
        OPTIVAL_CONSTANTS.OPERATIONS_ADMIN,
        OPTIVAL_CONSTANTS.SUPER_ADMIN,
        OPTIVAL_CONSTANTS.SUPERVISOR,
      ])
    ) {
      tableHeadCell.push({
        id: "assign",
        label: t("opva.assign"),
        sorting: false,
        sortingProperty: "",
        width: 10,
        position: "center",
      });
    }
    if (
      checkRole([
        OPTIVAL_CONSTANTS.ORGANIZATION_ADMIN,
        OPTIVAL_CONSTANTS.OPERATIONS_ADMIN,
        OPTIVAL_CONSTANTS.SUPER_ADMIN,
        OPTIVAL_CONSTANTS.SUPERVISOR,
        OPTIVAL_CONSTANTS.CONTENT_ADMIN,
      ])
    ) {
      tableHeadCell.push({
        id: "edit",
        label: t("opva.edit"),
        sorting: false,
        sortingProperty: "",
        width: 10,
        position: "center",
      });
    }
    if (
      checkRole([
        OPTIVAL_CONSTANTS.ORGANIZATION_ADMIN,
        OPTIVAL_CONSTANTS.OPERATIONS_ADMIN,
        OPTIVAL_CONSTANTS.SUPER_ADMIN,
      ])
    ) {
      tableHeadCell.push({
        id: "delete",
        label: t("opva.delete"),
        sorting: false,
        sortingProperty: "",
        width: 10,
        position: "center",
      });
    }
    return tableHeadCell;
  };
  const getAvailableWFHeaderCell = (): TableHeadCell[] => {
    const tableHeadCell: TableHeadCell[] = [];
    tableHeadCell.push(
      {
        id: "skillsName",
        label: t("opva.skillName"),
        sorting: false,
        sortingProperty: "skillsName",
        width: 25,
        position: "left",
      },
      {
        id: "level",
        label: t("opva.skillLevel"),
        sorting: false,
        sortingProperty: "level",
        width: 15,
        position: "left",
      },
      {
        id: "name",
        label: t("opva.workflow"),
        sorting: false,
        sortingProperty: "name",
        width: 25,
        position: "left",
      },
      {
        id: "version",
        label: t("opva.version"),
        sorting: false,
        sortingProperty: "version",
        width: 15,
        position: "center",
      },
      {
        id: "inprogress",
        label: t("opva.inProgress"),
        sorting: false,
        sortingProperty: "inprogress",
        width: 10,
        position: "center",
      },
      {
        id: "notify",
        label: t("opva.notify"),
        sorting: false,
        sortingProperty: "notify",
        width: 15,
        position: "center",
      }
    );
    return tableHeadCell;
  };
  const getAvailableUserGroupHeaderCell = (): TableHeadCell[] => {
    const tableHeadCell: TableHeadCell[] = [];
    tableHeadCell.push(
      {
        id: "firstName",
        label: t("opva.users"),
        sorting: true,
        sortingProperty: "firstName",
        width: 28,
        position: "left",
      },
      {
        id: "level",
        label: t("opva.groupName"),
        sorting: false,
        sortingProperty: "level",
        width: 10,
        position: "left",
      },
    );
    return tableHeadCell;
  };
  return { getSkillzHeaderCell, getAvailableWFHeaderCell, getAvailableUserGroupHeaderCell };
};
